import React, { useState, useEffect } from 'react'
import { Text, View, TouchableOpacity, TextInput } from 'react-native';
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Picker } from '@react-native-picker/picker';
import { collection, query, where, getDocs, getFirestore, addDoc } from "firebase/firestore";
import axios from 'axios';
import styles from './style';


export default function Reset({ navigation }) {

    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [diplo, setDiplo] = useState("");
    const [grupo, setGrupo] = useState("");

    const [retorno, setRetorno] = useState([])

    const getResumos = async () => {

        const db = getFirestore();
        const citiesRef = collection(db, "Usuarios");
        const q = query(citiesRef, where("email", "==", email),);
        let array = [];

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            console.log(doc.id, " => ", doc.data());

            const Obj = {
                id: doc.id,
                email: doc.data().email,
                nome: doc.data().nome,
                grupo: doc.data().grupo,
                diplo: doc.data().diplo,
            };
            array.push(Obj)
        });

        setRetorno(array)
    }

    const Reset = async () => {
        const url = 'https://api-reset-ctt.vercel.app/sincronizar-usuario';

        const dados = {
            nome: nome,
            email: email,
            diplo: diplo,
            grupo: grupo
        };

        try {
            const response = await axios.post(url, dados, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            console.log('Resposta da API:', response.data);
            await getResumos()
            alert("Reset feito com sucesso")
            setEmail("")
            setNome("")
        } catch (error) {
            console.error('Erro na requisição:', error.response?.data || error.message);
            alert("Erro ao realizar reset")
        }

    }

    return (

        <View style={styles.container}>

            <View style={styles.header}>
                <View>
                    <Text style={styles.Title}>Reset de Alunos</Text>
                </View>

                <TouchableOpacity style={styles.buttomMenu} onPress={() => navigation.goBack()} >
                    <MaterialCommunityIcons
                        name="reply"
                        size={40}
                        color="#ffffff" />
                </TouchableOpacity>

            </View>

            <View style={{ flexDirection: "row", alignItems: "flex-start", justifyContent: "center", marginTop: 175 }}>

                <View style={{ alignItems: "center", alignContent: "center", alignSelf: "center", justifyContent: "center" }}>

                    <TextInput
                        style={[styles.input, styles.shadowProp]}
                        placeholder="Nome do Aluno"
                        placeholderTextColor="#000"
                        type="text"
                        onChangeText={(text) => setNome(text)}
                        value={nome}
                    />

                    <TextInput
                        style={[styles.input, styles.shadowProp]}
                        placeholder="Email"
                        placeholderTextColor="#000"
                        type="text"
                        onChangeText={(text) => setEmail(text)}
                        value={email}
                    />

                    <Picker
                        selectedValue={diplo}
                        style={[styles.input, styles.shadowProp]}
                        onValueChange={(itemValue) => setDiplo(itemValue)}>

                        <Picker.Item label="Diplomado" value="Diplomado" />
                        <Picker.Item label="Formula" value="Formula" />
                        <Picker.Item label="Intercept" value="Intercept" />
                        <Picker.Item label="Intercept Course" value="Intercept Course" />
                        <Picker.Item label="Alineadores" value="Alineadores" />
                        <Picker.Item label="DAO" value="DAO" />
                        <Picker.Item label="COE" value="COE" />

                    </Picker>

                    <Picker
                        selectedValue={grupo}
                        style={[styles.input, styles.shadowProp]}
                        onValueChange={(itemValue) => setGrupo(itemValue)}>

                        <Picker.Item label="Qual Grupo?" value="Qual Grupo?" />
                        <Picker.Item label="1" value="1" />
                        <Picker.Item label="2" value="2" />
                        <Picker.Item label="3" value="3" />
                        <Picker.Item label="4" value="4" />
                        <Picker.Item label="5" value="5" />
                        <Picker.Item label="6" value="6" />
                        <Picker.Item label="7" value="7" />
                        <Picker.Item label="8" value="8" />
                        <Picker.Item label="9" value="9" />
                        <Picker.Item label="10" value="10" />
                        <Picker.Item label="11" value="11" />
                        <Picker.Item label="12" value="12" />
                        <Picker.Item label="13" value="13" />
                        <Picker.Item label="14" value="14" />
                        <Picker.Item label="15" value="15" />
                        <Picker.Item label="16" value="16" />
                        <Picker.Item label="17" value="17" />
                        <Picker.Item label="18" value="18" />
                        <Picker.Item label="19" value="19" />
                        <Picker.Item label="20" value="20" />
                        <Picker.Item label="21" value="21" />
                        <Picker.Item label="22" value="22" />
                        <Picker.Item label="23" value="23" />
                        <Picker.Item label="24" value="24" />
                        <Picker.Item label="25" value="25" />

                    </Picker>


                    <TouchableOpacity style={styles.ButtomCadastrar} onPress={() => { Reset() }}>
                        <Text style={styles.textButtomCadastar}>Resetar</Text>
                    </TouchableOpacity>

                </View>

                <View>
                    <View style={{ height: 10 }} />
                    <View style={styles.Alinhador}>
                        <View style={styles.Nome}>
                            <Text style={styles.textTabela}>Nome do aluno</Text>
                        </View>
                        <View style={styles.Email}>
                            <Text style={styles.textTabela}>Email</Text>
                        </View>
                        <View style={styles.Grupo_Diplo}>
                            <Text style={styles.textTabela}>Grupo</Text>
                        </View>
                        <View style={styles.Grupo_Diplo}>
                            <Text style={styles.textTabela}>Diplomado</Text>
                        </View>

                    </View>

                    {retorno && retorno.map((item) => {
                        return (
                            <>
                                <View style={styles.Alinhador}>
                                    <View style={styles.Item_Nome}>
                                        <Text style={styles.textTabela}>{item.nome}</Text>
                                    </View>

                                    <View style={styles.Item_Email}>
                                        <Text style={styles.textTabela}>{item.email}</Text>
                                    </View>

                                    <View style={styles.Item_Grupo_Diplo}>
                                        <Text style={styles.textTabela}>{item.grupo}</Text>
                                    </View>

                                    <View style={styles.Item_Grupo_Diplo}>
                                        <Text style={styles.textTabela}>{item.diplo}</Text>
                                    </View>
                                </View>
                            </>
                        )
                    })}
                </View>

            </View>
        </View>
    );
}


